var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmbedView)?_c('fragment',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{staticClass:"header-container grey"},[_c('AppHeaderLayoutDesktop',{attrs:{"user-id":_vm.userId,"user-info":_vm.userInfo}})],1):_c('TopHeaderSignUp')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }